import { isProductionEnvironment } from 'src/utils/environment/isProductionEnvironment';

export function getAmbitMenuWebUrl(): string {
    return isProductionEnvironment() ? 'ambit.la' : 'dev.ambit.la';
}
